module.exports = __webpack_public_path__ + "img/carscount.45d5c859.svg";